var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h157v80H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1364",
    transform: "translate(-700 -2926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(700 2926)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720 2940h228a8 8 0 0 1 8 8v16H712v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 2940.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V2948a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(722 2949)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(730 2949)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(738 2949)",
    fill: "#00c243"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712 2963h244v20H712z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M712.5 2963.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(722 2968)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(882 2971)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(898 2971)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(914 2971)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(930 2971)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1585",
    fill: "#c7cbd1",
    d: "M892 2983h64v192h-64z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1574",
    width: 57,
    height: 9,
    rx: 1,
    transform: "translate(725 3021)",
    fill: "#a6acb6"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1352",
    transform: "translate(-22)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1583",
    transform: "translate(766 2996)",
    fill: "#fff",
    stroke: "#a6acb6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 16,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 15,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1584",
    width: 51,
    height: 4,
    rx: 1,
    transform: "translate(773 3002)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1351"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 169",
    d: "M838.651 3021H877.6c2.017 0 3.651 1.343 3.651 3v10c0 1.657-1.635 3-3.651 3h-38.949c-2.016 0-3.651-1.343-3.651-3v-10c0-1.657 1.635-3 3.651-3Z",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 170",
    d: "m841.53 3029.344.558-1.572h.012l.536 1.572Zm.09-2.628L840 3031h.948l.336-.954h1.6l.326.954h.978l-1.602-4.284Zm5.052 2.724a1.893 1.893 0 0 1-.036.372 1.008 1.008 0 0 1-.12.321.638.638 0 0 1-.225.225.676.676 0 0 1-.355.084.633.633 0 0 1-.339-.087.748.748 0 0 1-.234-.228.983.983 0 0 1-.127-.321 1.58 1.58 0 0 1-.042-.36 1.71 1.71 0 0 1 .039-.369.981.981 0 0 1 .126-.315.664.664 0 0 1 .227-.222.692.692 0 0 1 .35-.084.659.659 0 0 1 .348.084.693.693 0 0 1 .225.219.9.9 0 0 1 .123.312 1.848 1.848 0 0 1 .04.369Zm.012 1.16v.4h.81v-4.284h-.852v1.56h-.012a.915.915 0 0 0-.394-.345 1.22 1.22 0 0 0-.525-.117 1.276 1.276 0 0 0-.6.135 1.286 1.286 0 0 0-.429.357 1.567 1.567 0 0 0-.258.513 2.094 2.094 0 0 0-.087.6 2.229 2.229 0 0 0 .087.624 1.661 1.661 0 0 0 .258.531 1.229 1.229 0 0 0 .435.366 1.326 1.326 0 0 0 .612.135 1.307 1.307 0 0 0 .549-.111.879.879 0 0 0 .394-.364Zm3.652-1.16a1.893 1.893 0 0 1-.036.372 1.008 1.008 0 0 1-.12.321.638.638 0 0 1-.225.225.676.676 0 0 1-.351.084.633.633 0 0 1-.339-.087.748.748 0 0 1-.229-.228.983.983 0 0 1-.135-.321 1.58 1.58 0 0 1-.042-.36 1.71 1.71 0 0 1 .039-.369.981.981 0 0 1 .126-.315.664.664 0 0 1 .231-.222.692.692 0 0 1 .354-.084.659.659 0 0 1 .348.084.693.693 0 0 1 .225.219.9.9 0 0 1 .123.312 1.847 1.847 0 0 1 .031.369Zm.014 1.16v.4h.81v-4.284h-.852v1.56h-.012a.915.915 0 0 0-.393-.345 1.22 1.22 0 0 0-.525-.117 1.276 1.276 0 0 0-.6.135 1.286 1.286 0 0 0-.429.357 1.567 1.567 0 0 0-.258.513 2.094 2.094 0 0 0-.087.6 2.229 2.229 0 0 0 .087.624 1.661 1.661 0 0 0 .258.531 1.229 1.229 0 0 0 .435.366 1.326 1.326 0 0 0 .612.138 1.307 1.307 0 0 0 .549-.111.879.879 0 0 0 .391-.367Zm3.78-.612h-.81a1.043 1.043 0 0 0 .141.519 1.03 1.03 0 0 0 .33.333 1.394 1.394 0 0 0 .459.18 2.57 2.57 0 0 0 .528.054 2.64 2.64 0 0 0 .519-.051 1.316 1.316 0 0 0 .453-.177.984.984 0 0 0 .321-.333.989.989 0 0 0 .123-.513.722.722 0 0 0-.084-.363.769.769 0 0 0-.222-.246 1.194 1.194 0 0 0-.315-.159 3.6 3.6 0 0 0-.363-.1q-.18-.042-.354-.078a2.738 2.738 0 0 1-.309-.081.648.648 0 0 1-.219-.117.234.234 0 0 1-.084-.186.23.23 0 0 1 .048-.153.315.315 0 0 1 .117-.087.521.521 0 0 1 .153-.039 1.471 1.471 0 0 1 .156-.009.85.85 0 0 1 .4.087.373.373 0 0 1 .186.333h.81a1.018 1.018 0 0 0-.147-.477.971.971 0 0 0-.309-.3 1.293 1.293 0 0 0-.423-.162 2.458 2.458 0 0 0-.489-.048 2.664 2.664 0 0 0-.492.045 1.355 1.355 0 0 0-.432.156.862.862 0 0 0-.309.3.933.933 0 0 0-.117.492.663.663 0 0 0 .084.345.729.729 0 0 0 .222.234 1.24 1.24 0 0 0 .315.15q.177.057.363.1a5.092 5.092 0 0 1 .711.192q.255.1.255.288a.315.315 0 0 1-.054.189.409.409 0 0 1-.135.12.643.643 0 0 1-.18.066.911.911 0 0 1-.189.021.975.975 0 0 1-.243-.03.63.63 0 0 1-.209-.092.5.5 0 0 1-.147-.162.467.467 0 0 1-.059-.237Zm3.642-2.088v-.93h-.852v.93h-.516v.57h.516v1.83a.793.793 0 0 0 .078.378.556.556 0 0 0 .213.222.884.884 0 0 0 .312.1 2.487 2.487 0 0 0 .375.027q.126 0 .258-.006a2.027 2.027 0 0 0 .24-.021v-.66a1.194 1.194 0 0 1-.126.018q-.066.006-.138.006a.417.417 0 0 1-.288-.072.417.417 0 0 1-.072-.292v-1.532h.624v-.568Zm1.788 1.554a1.862 1.862 0 0 1 .036-.366.934.934 0 0 1 .123-.318.691.691 0 0 1 .231-.225.686.686 0 0 1 .36-.087.7.7 0 0 1 .363.087.682.682 0 0 1 .234.225.934.934 0 0 1 .123.318 1.862 1.862 0 0 1 .036.366 1.817 1.817 0 0 1-.036.363.967.967 0 0 1-.123.318.648.648 0 0 1-.234.225.722.722 0 0 1-.363.084.705.705 0 0 1-.36-.084.655.655 0 0 1-.231-.225.967.967 0 0 1-.123-.318 1.817 1.817 0 0 1-.036-.365Zm-.852 0a1.88 1.88 0 0 0 .114.672 1.458 1.458 0 0 0 .324.513 1.417 1.417 0 0 0 .5.327 1.813 1.813 0 0 0 .66.114 1.837 1.837 0 0 0 .663-.114 1.412 1.412 0 0 0 .507-.327 1.458 1.458 0 0 0 .324-.513 1.88 1.88 0 0 0 .114-.672 1.9 1.9 0 0 0-.114-.675 1.453 1.453 0 0 0-.324-.516 1.446 1.446 0 0 0-.507-.33 1.8 1.8 0 0 0-.663-.117 1.772 1.772 0 0 0-.66.117 1.452 1.452 0 0 0-.5.33 1.453 1.453 0 0 0-.324.516 1.9 1.9 0 0 0-.114.673Zm5.874-.462h.834a1.167 1.167 0 0 0-.144-.519 1.172 1.172 0 0 0-.327-.366 1.417 1.417 0 0 0-.456-.219 1.945 1.945 0 0 0-.531-.072 1.692 1.692 0 0 0-.672.126 1.414 1.414 0 0 0-.5.351 1.505 1.505 0 0 0-.309.534 2.067 2.067 0 0 0-.1.669 1.737 1.737 0 0 0 .114.639 1.489 1.489 0 0 0 .318.5 1.417 1.417 0 0 0 .5.327 1.7 1.7 0 0 0 .627.116 1.549 1.549 0 0 0 1.014-.324 1.406 1.406 0 0 0 .48-.942h-.822a.809.809 0 0 1-.207.459.624.624 0 0 1-.471.171.6.6 0 0 1-.336-.09.672.672 0 0 1-.219-.231 1.058 1.058 0 0 1-.117-.315 1.685 1.685 0 0 1-.036-.342 1.757 1.757 0 0 1 .036-.351 1.037 1.037 0 0 1 .123-.324.739.739 0 0 1 .225-.24.6.6 0 0 1 .342-.093.571.571 0 0 1 .634.534Zm1.41-2.274V3031h.852v-1.068l.33-.318.852 1.386h1.032l-1.3-1.962 1.168-1.138h-1.008l-1.074 1.114v-2.3Zm4.86-.1h-.716a3.658 3.658 0 0 0-.345.63 5.284 5.284 0 0 0-.246.708 5.913 5.913 0 0 0-.15.735 5.155 5.155 0 0 0-.051.705 4.781 4.781 0 0 0 .207 1.392 5.589 5.589 0 0 0 .585 1.3h.708a5.427 5.427 0 0 1-.5-1.344 6.494 6.494 0 0 1-.153-1.41 6.28 6.28 0 0 1 .156-1.4 5.227 5.227 0 0 1 .505-1.32Zm.942 3.378h-.81a1.043 1.043 0 0 0 .141.519 1.03 1.03 0 0 0 .33.333 1.394 1.394 0 0 0 .459.18 2.57 2.57 0 0 0 .528.054 2.64 2.64 0 0 0 .519-.051 1.316 1.316 0 0 0 .453-.177.984.984 0 0 0 .322-.337.989.989 0 0 0 .122-.517.722.722 0 0 0-.084-.363.769.769 0 0 0-.222-.246 1.194 1.194 0 0 0-.315-.159 3.6 3.6 0 0 0-.363-.1q-.18-.042-.354-.078a2.738 2.738 0 0 1-.309-.081.648.648 0 0 1-.219-.117.234.234 0 0 1-.084-.186.23.23 0 0 1 .048-.153.315.315 0 0 1 .117-.087.521.521 0 0 1 .153-.039 1.471 1.471 0 0 1 .156-.009.85.85 0 0 1 .4.087.373.373 0 0 1 .186.333h.81a1.018 1.018 0 0 0-.147-.477.971.971 0 0 0-.309-.3 1.293 1.293 0 0 0-.423-.162 2.458 2.458 0 0 0-.489-.048 2.664 2.664 0 0 0-.492.045 1.355 1.355 0 0 0-.432.156.862.862 0 0 0-.309.3.933.933 0 0 0-.117.492.663.663 0 0 0 .084.345.729.729 0 0 0 .222.234 1.24 1.24 0 0 0 .315.15q.177.057.363.1a5.092 5.092 0 0 1 .711.192q.255.1.255.288a.315.315 0 0 1-.054.189.409.409 0 0 1-.135.12.643.643 0 0 1-.18.066.911.911 0 0 1-.189.021.975.975 0 0 1-.243-.03.63.63 0 0 1-.207-.093.5.5 0 0 1-.147-.162.467.467 0 0 1-.061-.236Zm2.2 2.094h.708a3.6 3.6 0 0 0 .348-.624 5.082 5.082 0 0 0 .249-.705 5.452 5.452 0 0 0 .147-.732 5.471 5.471 0 0 0 .048-.705 4.841 4.841 0 0 0-.207-1.4 5.557 5.557 0 0 0-.585-1.308h-.7a5.807 5.807 0 0 1 .486 1.35 6.454 6.454 0 0 1 .156 1.416 6.089 6.089 0 0 1-.159 1.389 5.63 5.63 0 0 1-.489 1.315Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1592",
    width: 35,
    height: 6,
    rx: 1,
    transform: "translate(898 2989)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1356"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1354",
    transform: "translate(0 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1586",
    width: 12,
    height: 8,
    rx: 4,
    transform: "translate(898 2996)",
    fill: "#abb1ba"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(900 2998)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1590",
    width: 35,
    height: 4,
    rx: 1,
    transform: "translate(914 3027)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1591",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(914 3033)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1357",
    transform: "translate(0 25)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1354",
    transform: "translate(0 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1586",
    width: 12,
    height: 8,
    rx: 4,
    transform: "translate(898 2996)",
    fill: "#abb1ba"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(900 2998)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1590",
    width: 35,
    height: 4,
    rx: 1,
    transform: "translate(914 3027)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1591",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(914 3033)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1358",
    transform: "translate(0 43)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1354",
    transform: "translate(0 29)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1586",
    width: 12,
    height: 8,
    rx: 4,
    transform: "translate(898 2996)",
    fill: "#abb1ba"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(900 2998)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1590",
    width: 35,
    height: 4,
    rx: 1,
    transform: "translate(914 3027)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1591",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(914 3033)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1355",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1353"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1586",
    width: 12,
    height: 8,
    rx: 4,
    transform: "translate(898 2996)",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(904 2998)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1587",
    width: 35,
    height: 4,
    rx: 1,
    transform: "translate(914 2998)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1588",
    width: 35,
    height: 4,
    rx: 1,
    transform: "translate(914 3004)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1589",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(914 3010)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 35",
    fill: "none",
    stroke: "#abb1ba",
    d: "M898.5 3044.5h51"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1593",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(725 3033)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1359"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26",
    fill: "#c7cbd1",
    d: "M725 3043h157v15H725z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(741 3049)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1594",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(834 3049)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(729 3047)",
    fill: "#abb1ba"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1360",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26",
    fill: "#fff",
    d: "M725 3043h157v15H725z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 70,
    height: 4,
    rx: 1,
    transform: "translate(741 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1594",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(834 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(729 3047)",
    fill: "#fd0826"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 24",
    transform: "translate(725 3075)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1363"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1361",
    transform: "translate(-725 -3043)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26",
    fill: "#fff",
    d: "M725 3043h157v15H725z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 63,
    height: 4,
    rx: 1,
    transform: "translate(741 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1594",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(834 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(729 3047)",
    fill: "#abb1ba"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1362",
    transform: "translate(-725 -3027)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26",
    fill: "#fff",
    d: "M725 3043h157v15H725z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 57,
    height: 4,
    rx: 1,
    transform: "translate(741 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1594",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(834 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(729 3047)",
    fill: "#abb1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1363"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1361",
    transform: "translate(-725 -3011)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26",
    fill: "#fff",
    d: "M725 3043h157v15H725z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 63,
    height: 4,
    rx: 1,
    transform: "translate(741 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1594",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(834 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(729 3047)",
    fill: "#abb1ba"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1362",
    transform: "translate(-725 -2995)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26",
    fill: "#fff",
    d: "M725 3043h157v15H725z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 57,
    height: 4,
    rx: 1,
    transform: "translate(741 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1594",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(834 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(729 3047)",
    fill: "#abb1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1363"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1361",
    transform: "translate(-725 -2979)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26",
    fill: "#fff",
    d: "M725 3043h157v15H725z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 63,
    height: 4,
    rx: 1,
    transform: "translate(741 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1594",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(834 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(729 3047)",
    fill: "#abb1ba"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1362",
    transform: "translate(-725 -2963)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 26",
    fill: "#fff",
    d: "M725 3043h157v15H725z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 57,
    height: 4,
    rx: 1,
    transform: "translate(741 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1594",
    width: 16,
    height: 4,
    rx: 1,
    transform: "translate(834 3049)",
    fill: "#c0c5cb",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(729 3047)",
    fill: "#abb1ba"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.0a7db4d2bace8729d52e65a2e07683f0.svg";
export { ForwardRef as ReactComponent };